import { tv } from 'tailwind-variants'

import { h5 } from '@ui-kit/core/typography'

export const flag = tv({
  slots: {
    container: 'absolute z-10 flex items-center justify-center',
    box: 'relative rounded-t-lg bg-brand-dark px-2.5 py-1',
    text: h5({ color: 'uiLight' }),
  },
  variants: {
    position: {
      top: {
        container: 'left-0 right-0 top-0',
        box: 'rounded-b-lg rounded-t-none',
      },
      right: {
        container: 'bottom-0 right-0 top-0',
        box: '-right-1/2 -translate-x-3.5 -rotate-90',
      },
      bottom: {
        container: 'bottom-0 left-0 right-0',
      },
      left: {
        container: 'bottom-0 left-0 top-0',
        box: '-left-1/2 translate-x-3.5 rotate-90',
      },
    },
  },
  defaultVariants: {
    position: 'top',
  },
})
